<section class="bg-deep">
  <div class="logo mb-4">
    <img
      src="./assets/images/brand_white.png"
      alt="Union Solutions"
      loading="lazy"
    />
  </div>

  <div class="card">

    <div class="card-body py-4 d-flex flex-column justify-content-between">
      <div>
        <label class="fw-500" for="login">Login - Union Solutions</label>
        <input
          [formControl]="form.controls['login']"
          id="login"
          type="text"
          class="form-control"
        />
        <label class="pt-3 fw-500" for="password">Senha</label>
        <input
          (keyup.enter)="login($event)"
          [formControl]="form.controls['senha']"
          id="password"
          type="password"
          class="form-control"
        />
        <button (click)="login($event)" class="btn btn-primary mt-4 w-100">
          Entrar
        </button>
      </div>
      <a
        [routerLink]="'/recuperar-senha'"
        class="w-100 btn fw-500 mt-4 btn-outline-primary btn-icon w-100 border-0"
      >
        <span>Esqueceu sua senha</span><i class="mdi mdi-help-circle"></i>
      </a>
    </div>
    
  </div>
</section>
